export const MODIFY_DAILY_DEPOSIT_FETCHING = 'MODIFY_DAILY_DEPOSIT_FETCHING';
export const MODIFY_DAILY_DEPOSIT_FETCHING_TABLE_DATA =
  'MODIFY_DAILY_DEPOSIT_FETCHING_TABLE_DATA';
export const MODIFY_DAILY_DEPOSIT_FETCH_ERROR =
  'MODIFY_DAILY_DEPOSIT_FETCH_ERROR';
export const MODIFY_DAILY_DEPOSIT_GET_DATA = 'MODIFY_DAILY_DEPOSIT_GET_DATA';
export const MODIFY_DAILY_DEPOSIT_GET_SITES = 'MODIFY_DAILY_DEPOSIT_GET_SITES';
export const MODIFY_DAILY_DEPOSIT_DELETED = 'MODIFY_DAILY_DEPOSIT_DELETED';
export const MODIFY_DAILY_DEPOSIT_SET_FROM_DATE =
  'MODIFY_DAILY_DEPOSIT_SET_FROM_DATE';
export const MODIFY_DAILY_DEPOSIT_SET_TO_DATE =
  'MODIFY_DAILY_DEPOSIT_SET_TO_DATE';
export const MODIFY_DAILY_DEPOSIT_SET_SITE = 'MODIFY_DAILY_DEPOSIT_SET_SITE';
export const MODIFY_DAILY_DEPOSIT_SET_ISSUPPER =
  'MODIFY_DAILY_DEPOSIT_SET_ISSUPPER';
export const MODIFY_DAILY_DEPOSIT_EXISTS = 'MODIFY_DAILY_DEPOSIT_EXISTS';



// WEBPACK FOOTER //
// ./src/pages/modifydailydeposits/state/modifydailydepositgrid/types.js